import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  readOnly?: boolean;
}
export function Input({
  className,
  label,
  error,
  readOnly,
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-1261">
      {label && <label className="block text-xs font-semibold text-[#6B6B76] mb-2 uppercase tracking-wider" data-id="element-1262">
          {label}
        </label>}
      <input readOnly={readOnly} className={`
          flex h-12 w-full rounded-xl border border-[#E8E8ED] bg-white px-4 py-3 text-sm text-[#2D2D2D]
          placeholder:text-[#9B9BA7] transition-all duration-200
          focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FC4C02] focus-visible:ring-offset-0 focus-visible:border-transparent
          disabled:cursor-not-allowed disabled:opacity-50
          ${readOnly ? 'bg-[#F7F7FA] text-[#6B6B76] cursor-default' : 'hover:border-[#D0D0D8]'}
          ${error ? 'ring-2 ring-[#E34402] border-transparent' : ''}
          ${className || ''}
        `} {...props} data-id="element-1263" />
      {error && <p className="mt-2 text-xs text-[#E34402] font-medium" data-id="element-1264">{error}</p>}
    </div>;
}